import React from 'react';
import { faqs } from '../mock/data';
import { useReveal } from '../hooks/useReveal';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

export default function FAQ() {
  const { ref, inView } = useReveal();
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="container-x max-w-3xl">
        <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} text-center`}>
          <span className="section-eyebrow">FAQ</span>
          <h2 className="section-title mt-4 text-[34px] md:text-[44px] leading-tight">Frequently asked questions</h2>
          <p className="mt-4 text-slate-600">Everything you need to know about admissions and student life at PCA.</p>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border border-[var(--pca-border)] rounded-2xl px-5 bg-white shadow-[0_10px_30px_-25px_rgba(11,46,110,0.4)] data-[state=open]:border-[var(--pca-blue)]">
              <AccordionTrigger className="text-left text-[#0B2E6E] font-semibold text-[16px] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
